export const resistAtkType = [
  'ChaAtkType_1',
  'ChaAtkType_2',
  'ChaAtkType_3',
  'ChaAtkType_4',
  'ChaAtkType_5',
  'ChaAtkType_6',
  'ChaAtkType_7',
];
export const AtkTypeKOR = {
  참격: 'ChaAtkType_1',
  타격: 'ChaAtkType_2',
  화염: 'ChaAtkType_3',
  냉기: 'ChaAtkType_4',
  전격: 'ChaAtkType_5',
  신성: 'ChaAtkType_6',
  암흑: 'ChaAtkType_7',
};
export const AtkTypeENG = {
  S: 'ChaAtkType_1',
  C: 'ChaAtkType_2',
  F: 'ChaAtkType_3',
  I: 'ChaAtkType_4',
  L: 'ChaAtkType_5',
  H: 'ChaAtkType_6',
  D: 'ChaAtkType_7',
};
export const QuestRSC = [
  ['rsc_A', 'rsc_A_raw', 'rsc_A'],
  ['rsc_B', 'rsc_B_raw', 'rsc_B'],
  ['rsc_C', 'rsc_C_raw', 'rsc_C'],
  ['rsc_D', 'rsc_D_raw', 'rsc_D'],
];